/**
 * Bounds for the quiz `questionsPerRound` field. Frontend mirrors the
 * server-side cap that the inner-reality-backend enforces (see Tier 3 thread
 * 28-experience-source-tier3.md — backend cap raise pending).
 */
export const QUESTIONS_PER_ROUND_MIN = 1
export const QUESTIONS_PER_ROUND_MAX = 100
export const QUESTIONS_PER_ROUND_DEFAULT = 10

/**
 * Clamp a `questionsPerRound` candidate into the valid range. Non-finite or
 * sub-min input returns the MIN; over-max returns the MAX. The default value
 * (`QUESTIONS_PER_ROUND_DEFAULT`) is only used when the input is `undefined`
 * / `null` / NaN-like.
 */
export function clampQuestionsPerRound(value: number | undefined | null): number {
    if (value === undefined || value === null) return QUESTIONS_PER_ROUND_DEFAULT
    const n = Number(value)
    if (!Number.isFinite(n)) return QUESTIONS_PER_ROUND_DEFAULT
    if (n < QUESTIONS_PER_ROUND_MIN) return QUESTIONS_PER_ROUND_MIN
    if (n > QUESTIONS_PER_ROUND_MAX) return QUESTIONS_PER_ROUND_MAX
    return Math.trunc(n)
}

/**
 * Validate a `questionsPerRound` candidate. Returns `null` for valid input,
 * otherwise a human-readable rejection reason. Useful for unit tests + future
 * server-side validation parity.
 */
export function validateQuestionsPerRound(
    value: number | undefined | null,
): string | null {
    if (value === undefined || value === null) return null
    const n = Number(value)
    if (!Number.isFinite(n)) return 'questionsPerRound must be a finite number'
    if (!Number.isInteger(n)) return 'questionsPerRound must be an integer'
    if (n < QUESTIONS_PER_ROUND_MIN) {
        return `questionsPerRound must be >= ${QUESTIONS_PER_ROUND_MIN}`
    }
    if (n > QUESTIONS_PER_ROUND_MAX) {
        return `questionsPerRound must be <= ${QUESTIONS_PER_ROUND_MAX}`
    }
    return null
}
